import { DirectUploadMedia } from "libs/directUpload";
import { Reseller } from "modules/resellers";
import { SharingSocials } from "modules/sharing";

import { Attribute, Category } from "../categories/categories.types";
import {
  EProductVariantVisibility,
  ProductBadgeCategory,
  ProductBadgeLabel,
} from "./constants";

export interface ProductsListItem {
  id: string;
  productId: string;
  categoryId: string;
  image: DirectUploadMedia;
  name: string;
  categoryName: string;
  createdAt: string;
  updatedAt: string;
  price: number;
  discountedPrice: number;
  productsSold?: number;
  barcodes: ProductDetailsVariantBarcode[];
  colorAttributeValue: ColorAttributeValue;
  visibility: EProductVariantVisibility;
  sharingsCount?: {
    socialMedia: Array<{ name: SharingSocials | null; count: number }>;
    variantId: string;
  };
}

export interface ProductDetailsVariantBarcode {
  id: string;
  value: string;
  productVariantId: string;
  availableItemsCount: number;
  reservedItemsCount?: number;
  warehouseItemsCount?: number;
  sizeAttributeValueId: string;
  sizeAttributeValue: { id: string; attributeId: string; value: string };
}

export interface ProductDetailsData {
  id: string;
  attributeValues: ProductDetailsAttribute[];
  category: Category;
  categoryId: string;
  description: string;
  isChapshopChoice: boolean;
  isVerified: boolean;
  googleDriveLink?: string | null;
  generalVideo: DirectUploadMedia;
  realVideo?: DirectUploadMedia | null;
  variants: ProductDetailsVariant[];
}

interface ProductDetailsAttribute {
  id: string;
  attributeId: string;
  value: string;
  attribute: Attribute;
}

export interface ProductDetailsVariant {
  id: string;
  name: string;
  shortTitle: string | null;
  barcodes: ProductDetailsVariantBarcode[];
  images: DirectUploadMedia[];
  previewId: string | null;
  preview: DirectUploadMedia | null;
  compressedPreview: DirectUploadMedia | null;
  colorAttributeValueId: string;
  weight: number;
  volume: number;
  badge: ProductBadge | null;
  isBestSeller: boolean;
  isVerified: boolean;
  allowSellingBelowBuyingPrice: boolean;
  buyingPrice: number;
  merchantPrice: number;
  standardPrice: number;
  intermediateResellerPrice: number;
  confirmedResellerPrice: number;
  influencerPrice: number;
  visibility: EProductVariantVisibility;
  recommendedSellingPrice?: number | null;
  discount: number;
  discountAmount: number;
  suggestionDiscount: number;
  suggestionDiscountAmount: number;
  commission: number;
  commissionPercentage: number;
  influencerCommission: number;
  influencerCommissionPercentage: number;
  quantityDiscounts: ProductVariantBulkDiscount[];
  sku: string;
  shortId: string;
  variantsBoughtTogether: BothTogetherVariant[];
  colorAttributeValue: ColorAttributeValue;
  productId: string;
  createdAt: string;
  updatedAt: string;
}

interface ColorAttributeValue {
  id: string;
  attributeId: string;
  value: string;
}

export interface BothTogetherVariant {
  id: string;
  mainVariantId: string;
  variant: ProductDetailsVariant & {
    product: Omit<ProductDetailsData, "variants">;
  };
}

export interface ProductVariantBulkDiscount {
  id?: string;
  isDelete?: boolean;
  min: number;
  max: number;
  discount: number | null;
}

export interface ProductVariantBarcode {
  id?: string;
  isDelete?: boolean;
  value: string;
  sizeAttributeValueId: string;
}

export enum ProductStatusFilterValues {
  ALL = "all",
  VERIFIED = "verified",
  NOT_VEREFIED = "notVerified",
}

export interface ProductBoxListItem {
  id: string;
  createdAt: string;
  itemsCount: number;
  name: string;
  status: string;
  type: number;
  zone: "Pickup" | "Warehouse";
  updatedAt: string;
}

export interface ProductComment {
  id: string;
  productId: string;
  grade: number;
  countOfDislikes: number;
  countOfLikes: number;
  image: DirectUploadMedia | null;
  text: string;
  createdAt: string;
  reseller: Reseller;
}

export interface ProductBadge {
  id: string;
  category: ProductBadgeCategory;
  label: ProductBadgeLabel;
  createdAt: string;
}
